var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "18px",
    viewBox: "0 0 23 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C7555B00-915A-46F6-8454-8132FAEF0881@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop---My-Information",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Contact",
    transform: "translate(-748.000000, -1796.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(269.000000, 1700.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Input-/-Primary-/-Default-Copy-2",
    transform: "translate(465.000000, 58.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.6500639,43.0701571 C34.6500639,42.8722513 34.6500639,42.6743455 34.6402725,42.4858639 C35.5606641,41.8450262 36.363559,41.0439791 37,40.1298429 C36.1579395,40.4879581 35.2473393,40.7329843 34.287782,40.8460733 C35.2669221,40.2806283 36.0110685,39.3947644 36.363559,38.3298429 C35.4529587,38.8481675 34.4444444,39.2251309 33.3673904,39.4324607 C32.5057471,38.5465969 31.2818221,38 29.9208174,38 C27.3163048,38 25.2013623,40.0356021 25.2013623,42.5424084 C25.2013623,42.9005236 25.2405279,43.2492147 25.3286505,43.5790576 C21.4022989,43.3905759 17.9263516,41.5811518 15.5959983,38.8293194 C15.1945509,39.4984293 14.9595573,40.2806283 14.9595573,41.1099476 C14.9595573,42.6837696 15.7918263,44.078534 17.0647084,44.8890052 C16.2911877,44.8701571 15.5666241,44.6628272 14.9301831,44.3235602 C14.9301831,44.3424084 14.9301831,44.3612565 14.9301831,44.3801047 C14.9301831,46.5853403 16.5555556,48.4136126 18.7194551,48.8376963 C18.3277991,48.9413613 17.9067688,48.9979058 17.4759472,48.9979058 C17.1724138,48.9979058 16.8786718,48.9696335 16.5849298,48.913089 C17.1822052,50.7225131 18.9250745,52.0324607 20.99106,52.0701571 C19.3754789,53.2858639 17.3388676,54.0115183 15.1260111,54.0115183 C14.7441464,54.0115183 14.3720732,53.9926702 14,53.9455497 C16.0659855,55.2460733 18.5530013,56 21.2162622,56 C29.9012346,56 34.6500639,49.0732984 34.6500639,43.0701571 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.60990d32a0564fce79933a6e0381ab7c.svg";
export { ForwardRef as ReactComponent };